export enum ErrorCodes {
  /**
   * 无权限
   */
  EPERMISSION = "epermission",
  /**
   * 没有麦克风
   */
  EMIC = "emic",
  /**
   * 没有获取到麦克风音频流
   */
  EMICSTREAM = "emicstream",
  /**
   * 没有获取到系统的麦克风流
   */
  ESYSTEMSTREAM = "esystemstream",
  /**
   * 无法获取音频流，包括麦克风和系统
   */
  EAUDIOSTREAM = "eaudiostream",
}
